import Block from '../block'
import Swiper from 'swiper'

export default class Carousel extends Block {
	static title = 'carousel'

	init() {
		if (this.getElements('slide').length < 1) {
			return
		}

		this.swiper = new Swiper(this.element, {
			...this.element.dataset,

			autoplay: this.element.dataset.autoplay === 'true',

			wrapperClass: 'carousel__slides',
			slideClass: 'carousel__slide',

			speed: parseInt(this.element.dataset.speed, 10) || 300,

			navigation: {
				nextEl: this.getElement('controls__next'),
				prevEl: this.getElement('controls__prev'),
			},

			pagination: {
				el: this.getElement('progress'),
				type: this.element.dataset.paginationType || 'bullets',
				bulletClass: 'carousel__progress__bullet',
				bulletActiveClass: 'carousel__progress__bullet--active',
				clickable: true,
			},

			slidesPerView: this.element.dataset.items || 1,
			spaceBetween: 0,

			breakpoints: {
				567: {
					slidesPerView: this.element.dataset.itemsMobile || 1,
				},
				767: {
					slidesPerView: this.element.dataset.itemsMobileLandscape || 1,
				},
				959: {
					slidesPerView: this.element.dataset.itemsTablet || 1,
				},
				1139: {
					slidesPerView: this.element.dataset.itemsTabletLandscape || 1,
				},
				1439: {
					slidesPerView: this.element.dataset.itemsDesktop || 1,
				},
			},
		})
	}
}
